const getDefaultApiUrl = () => {
  if (import.meta.env.DEV) return 'http://localhost:8083'
  return 'https://platform-backend-v2-pk734zja6q-uc.a.run.app'
}

const getDefaultPortalUrl = () => {
  if (import.meta.env.DEV) return 'http://localhost:5174'
  return 'https://support.llamassist.ai'
}

export const API_BASE_URL = import.meta.env.VITE_API_URL || getDefaultApiUrl()

export const SUPPORT_PORTAL_URL = import.meta.env.VITE_SUPPORT_PORTAL_URL || getDefaultPortalUrl()

/** Llamigo chat backend — override with VITE_LLAMIGO_URL if separate from the main API host. */
export const LLAMIGO_API_URL = import.meta.env.VITE_LLAMIGO_URL || API_BASE_URL
